import axios from "axios";
import { STRINGS_ENV } from "../config/stringsEnv";

const API_URL = `${STRINGS_ENV.apiUrl}auth`;
const REQUEST_TIMEOUT = 12000;

export const authErrorMessage = (error, action = "login") => {
  const status = error?.response?.status;
  if (action === "register" && (status === 400 || status === 409))
    return "We couldn't create your account. Check your details. If you already registered, sign in or reset your password.";
  if (action === "login" && (status === 400 || status === 401 || status === 403))
    return "We couldn't sign you in. Check your email and password, then try again.";
  if (action === "reset" && (status === 400 || status === 401))
    return "This link is no longer valid. Please request a new one.";
  if (status === 429) return "Too many attempts. Please wait a few minutes before trying again.";
  if (!error?.response) return "We couldn't connect. Check your internet connection and try again.";
  return "Our service is temporarily unavailable. Please try again shortly.";
};

export const normalizeEmail = (value = "") =>
  String(value).trim().toLowerCase();

export const verifyToken = (token) => {
  return axios.get(`${API_URL}/verify`, {
    headers: { Authorization: `Bearer ${token}` },
    timeout: REQUEST_TIMEOUT,
  });
};

export const login = async (credentials) => {
  const { data } = await axios.post(`${API_URL}/login`, {
    ...credentials,
    username: normalizeEmail(credentials?.username),
  }, { timeout: REQUEST_TIMEOUT });
  return data;
};

export const logout = (token) =>
  axios.post(
    `${API_URL}/logout`,
    {},
    { headers: { Authorization: `Bearer ${token}` } }
  );

export const register = async (data) => {
  await axios.post(`${API_URL}/register`, {
    ...data,
    username: normalizeEmail(data?.username),
  }, { timeout: REQUEST_TIMEOUT });
  return true;
};

export const requestPasswordReset = async (username) => {
  const { data } = await axios.post(`${API_URL}/forgot-password`, {
    username: normalizeEmail(username),
  }, { timeout: REQUEST_TIMEOUT });
  return data;
};

export const resetPassword = async ({ token, password }) => {
  const { data } = await axios.post(`${API_URL}/reset-password`, {
    token,
    password,
  }, { timeout: REQUEST_TIMEOUT });
  return data;
};
